import { render, staticRenderFns } from "./LmSelect.vue?vue&type=template&id=2b5b0f60&"
import script from "./LmSelect.vue?vue&type=script&lang=js&"
export * from "./LmSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports